import React, { PureComponent } from 'react';
import { Link } from 'lego-on-react';
import b from 'b_';

import Vacancy from '@interfaces/vacancy';

import './vacancies.css';

const class_ = b.with('vacancies');

interface Props {
    vacancies: Vacancy[];
}

export default class Vacancies extends PureComponent<Props> {
    public renderTags(vacancy: Vacancy) {
        const { cities, tags, experience } = vacancy;

        const vacancyTags = [];
        if (cities.length) {
            vacancyTags.push(cities.join(', '));
        }
        if (tags.length) {
            vacancyTags.push(tags.join(', '));
        }
        if (experience.length) {
            vacancyTags.push(experience.join(', '));
        }
        if (!vacancyTags.length) {
            return null;
        }

        return (
            <div className={class_('tags')}>
                {vacancyTags.map(tag => (
                    <div className={class_('tag')} key={tag}>
                        {tag}
                    </div>
                ))}
            </div>
        );
    }

    public renderVacancy = (vacancy: Vacancy) => {
        const { key, url, title, shortDescription } = vacancy;

        return (
            <div className={class_('vacancy')} key={key}>
                <Link
                    theme="normal"
                    cls={class_('title')}
                    url={url}
                >
                    {title}
                </Link>

                {shortDescription &&
                    <div className={class_('description')}>
                        {shortDescription}
                    </div>
                }

                {this.renderTags(vacancy)}
            </div>
        );
    };

    public render() {
        const { vacancies } = this.props;

        return (
            <div className={class_()}>
                {vacancies.map(this.renderVacancy)}
            </div>
        );
    }
}
